import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents } from './components/PackContents';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { Guarantee, Footer } from './components/Footer';
import { EmotionalClose } from './components/EmotionalClose';
import { FretDivider } from './components/Ornaments';
import { FloatingWhatsApp } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen w-full rice-paper bg-[#F3EAD7] font-sans text-stone-700 antialiased selection:bg-red-100 selection:text-red-800" data-id="element-0" data-mp="31c9ts0k3atpv">
      <UrgencyBanner data-id="element-1" data-mp="28u5xmlt5v3cb" />
      <Hero data-id="element-2" data-mp="28tmej1rry8wp" />
      <PackContents data-id="element-3" data-mp="28t4lee0esat0" />
      <InitialTestimonials data-id="element-4" data-mp="28sl511qepuh3" />
      <PainPoints data-id="element-5" data-mp="23vchsmqej08z" />
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-6" data-mp="23vuoyeelqyvo">
        <Pricing data-id="element-7" data-mp="23ti5txx3yih1" />
      </div>
      <Guarantee data-id="element-8" data-mp="3ikh5q2ysagvt" />
      <FAQ data-id="element-9" data-mp="3iiwasc8k4vxf" />
      <FretDivider character="次" className="px-6 py-6" data-id="element-10" data-mp="3ijfw82xf22g7" />
      <EmotionalClose data-id="element-11" data-mp="3ml14faz09sk2" />
      <Footer data-id="element-12" data-mp="3mkho1yp07c85" />
      <FloatingWhatsApp data-id="element-13" data-mp="3mjzrt22ccy08" />
    </div>;
}